import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CallCenterDailerComponent } from '../call-center-dailer.component';


const routes: Routes = [
  {
    path : "",
    component : CallCenterDailerComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CallCenterDialerRoutingModule { }
